import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../config/authAxios";

const initialState = {
  status: null,
  loading: false,
  data: [],
  total: 0,
  error: "",
  message: "",
};

export const userWidthdrawTransactionsAction = createAsyncThunk(
  "user-widthdraw-transactions",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `/admins/api/user-widthdraw-transactions?s_date=${data?.startDate}&e_date=${data?.endDate}&publisher_id=${data?.publisher_id}&app_id=${data?.app_id}&page=${data?.page}&limit=${data?.limit}&search=${data?.search}`
      );
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const userWidthdrawTransactionSlice = createSlice({
  name: "user-widthdraw-transactions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userWidthdrawTransactionsAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(userWidthdrawTransactionsAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.data;
      state.total = action?.payload?.totalCount;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
    builder.addCase(userWidthdrawTransactionsAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
  },
});


export const userWidthdrawTransactionReducer = userWidthdrawTransactionSlice.reducer;
